import React, { useState } from 'react';
import { Form, Button, Card } from 'react-bootstrap';

const ProjectEdit = ({ project, onUpdateProject, onCancel }) => {
  const [editedProject, setEditedProject] = useState(project);

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setEditedProject({ ...editedProject, [e.target.name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdateProject(editedProject);
  };

  return (
    <Card>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Project name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={editedProject.name}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
               type="textarea" 
               name="description" 
               rows={3} 
              value={editedProject.description}
              onChange={handleChange}
            />
          </Form.Group>
          
          <Form.Group>
            <Form.Check
              type="checkbox"
              label="Active"
              name="is_active"
              checked={editedProject.is_active || false}
              onChange={handleChange}
            />
          </Form.Group>
          <br></br>
          <Button variant="primary" type="submit" className="mr-2">
            Update Project
          </Button>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ProjectEdit;